import * as React from 'react';
import { IBasePageProps } from '../../configuration/IConfiguration';

interface IPage404Props {
}

interface IPage404RouteParams {
    test: string;
}

interface IPage404QueryParams {
    test: string;
}

type Page404Props = IBasePageProps<IPage404RouteParams, IPage404QueryParams> & IPage404Props;

class Page404 extends React.Component<Page404Props, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <>
                <h2>404</h2>
                <h4>Page not found</h4>
            </>
        );
    }
}

export default Page404;